import { ThunkDispatch } from 'redux-thunk';
import {
  addNewUpdate,
  getLatestUpdatesAllList,
  removeUpdate,
} from '../../../features/latestUpdatesSlice';
import { isAPIFailed, isAPISuccess } from '../../../utils/Util';
import { CLICK_ACTIONS } from '../../../utils/Constant';

export const handleChange = (
  value: string,
  setUpdate: (param: string) => void
) => {
  if (value.length <= 150) setUpdate(value);
  else setUpdate(value.substring(0, 150));
};

export const handleCancel = (setUpdate: (param: string) => void) => {
  setUpdate('');
};

export const getUpdatesList = (
  currentPage: number,
  pageSize: number,
  dispatch: ThunkDispatch<any, any, any>
) => {
  dispatch(
    getLatestUpdatesAllList({
      pageNumber: currentPage,
      pagePerCount: pageSize,
    })
  );
};

export const handleUpload = (
  param: { currentPage: number; pageSize: number; update: string | undefined },
  setUpdate: (param: string) => void,
  setShowLoader: (param: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  toast: any
) => {
  const { currentPage, pageSize, update } = param;
  if (update) {
    setShowLoader(true);
    dispatch(addNewUpdate({ description: update }))
      .then((fulfilled: any) => {
        setShowLoader(false);
        if (isAPISuccess(fulfilled.payload)) {
          toast.success(fulfilled.payload.responseInformation.responseMessage);
          setUpdate('');
          getUpdatesList(currentPage, pageSize, dispatch);
        } else if (isAPIFailed(fulfilled.payload)) {
          toast.error(fulfilled.payload.responseInformation.responseMessage);
        }
      })
      .catch(() => {
        setShowLoader(false);
        toast.error('Adding latest update failed');
      });
  } else toast.error('Please enter the latest update');
};

export const handleRemove = (
  currentPage: number,
  pageSize: number,
  removeUpdateId: number | string,
  setShowLoader: (param: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  toast: any
) => {
  setShowLoader(true);
  dispatch(removeUpdate({ id: removeUpdateId }))
    .then((fulfilled: any) => {
      setShowLoader(false);
      if (isAPISuccess(fulfilled.payload)) {
        toast.success(fulfilled.payload.responseInformation.responseMessage);
        getUpdatesList(currentPage, pageSize, dispatch);
      } else if (isAPIFailed(fulfilled.payload)) {
        toast.error(fulfilled.payload.responseInformation.responseMessage);
      }
    })
    .catch(() => {
      setShowLoader(false);
      toast.error('removing latest update failed');
    });
};

export const onRemove = (
  id: number | string,
  setShowAlertPopUp: (params: boolean) => void,
  setRemoveUpdateId: (param: string | number) => void
) => {
  setShowAlertPopUp(true);
  setRemoveUpdateId(id);
};

export const alertPopupToggle = (
  params: {
    action: string;
    currentPage: number;
    pageSize: number;
    removeUpdateId: number | string;
  },
  setShowLoader: (param: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  toast: any,
  setShowAlertPopUp: (param: boolean) => void,
  setRemoveUpdateId: (param: any) => void
) => {
  const { action, currentPage, pageSize, removeUpdateId } = params;
  if (action === CLICK_ACTIONS.APPROVE) {
    handleRemove(
      currentPage,
      pageSize,
      removeUpdateId,
      setShowLoader,
      dispatch,
      toast
    );
  }
  setShowAlertPopUp(false);
  setRemoveUpdateId(null);
};
